import { createAsyncThunk } from "@reduxjs/toolkit";
//import { API_URL } from "src/utils/apiConfig";
//import axios from "axios";
import { userId } from "src/helpers/user_id";
import { apiClient } from '../../helpers/api_helper';

export const getTasks: any = createAsyncThunk("tasks/getTasks", async () => {
  try {
    const response = await apiClient.get(`/task/tasks/`);
    return response;
  } catch (error) {
    return error;
  }
});

export const addTask = createAsyncThunk("tasks/addTask", async (task: any) => {
  try {
    const response = await apiClient.post(`/task/tasks/`,{
        titulo: task.titulo,
        descricao: task.descricao,
        valor_gasto: task.valor_gasto,
        valor_estimado: task.valor_estimado,
        salvaguardas: task.salvaguardas,
        data_estimada: task.data_estimada,
        data_termino: task.data_termino,
        phase: task.phase,
        status: task.status,
        project: task.projecto,
        assigned_users: task.assignedUsers,
        create_user: userId,
        update_user: userId,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
});

export const updateTask = createAsyncThunk("tasks/updateTask", async (task: any) => {
    try {
      const response = await apiClient.put(`/task/tasks/${task.id}/`,{
          titulo: task.titulo,
          descricao: task.descricao,
          valor_gasto: task.valor_gasto,
          valor_estimado: task.valor_estimado,
          salvaguardas: task.salvaguardas,
          data_estimada: task.data_estimada,
          data_termino: task.data_termino,
          phase: task.phase,
          status: task.status,
          project: task.projecto,
          assigned_users: task.assignedUsers,
          create_user: userId,
          update_user: userId,
        }
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const deleteTask = createAsyncThunk("tasks/deleteTask", async (taskId: any) => {
    try {
      const response = await apiClient.delete(`/task/tasks/${taskId}/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getTasksByPhaseId = createAsyncThunk("tasks/getTasksByPhaseId", async (phaseId: any) => {
    try {
      const response = await apiClient.get(`/task/tasks/get-tasks-by-phase-id/${phaseId}/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);
